<template>
  <a-card :bordered='false'>
    <a-tabs v-model:activeKey="activeKey">
      <a-tab-pane :key="1" tab="店员首页设置">
        <homeSet></homeSet>
      </a-tab-pane>
      <a-tab-pane :key="2" tab="店员常用功能设置">
        <homeUsedSet></homeUsedSet>
      </a-tab-pane>
    </a-tabs>
  </a-card>
</template>
<script>
  import { ref } from "vue";
  import homeSet from './components/homeSet';
  import homeUsedSet from './components/homeUsedSet';
  export default {
    components: { homeSet, homeUsedSet },
    setup() {
      const activeKey = ref(1);
      return {
        activeKey
      };
    },
  };
</script>